import { SonCta } from '../components/cta'
import { Reveal, Stagger, StaggerItem } from '../components/hareket'
import { Baslik, Kart, Rozet, SayfaUstu, Section } from '../components/ui'
import { ENTEGRASYONLAR } from '../icerik/entegrasyonlar'
import { useHead } from '../lib/head'

export function Entegrasyonlar() {
  useHead(
    {
      title: 'Entegrasyonlar',
      description:
        'PayTR, İyzico, Kuveyt Türk, Param, Netgsm, Amazon SES, WhatsApp, LiveKit, Zoom, Paraşüt, Geliver, API ve webhook.',
    },
    '/entegrasyonlar',
  )
  const kategoriler = [...new Set(ENTEGRASYONLAR.map((e) => e.kategori))]
  const etiket = { hazir: null, gelistiriliyor: 'Geliştiriliyor', planlandi: 'Yakında' } as const
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0">
          <Reveal>
            <Baslik
              seviye="h1"
              eyebrow="Entegrasyonlar"
              baslik="Sizin hesabınız, bizim bağlantımız"
              metin="Ödeme ve SMS sağlayıcılarıyla sözleşme derneğindir; anahtarları panelden girersiniz, şifreli saklanır, para doğrudan derneğin hesabına geçer. Araya girmeyiz."
            />
          </Reveal>
          {kategoriler.map((k) => (
            <div key={k} className="mt-12">
              <Reveal>
                <h2 className="heading text-xl text-ink">{k}</h2>
              </Reveal>
              <Stagger className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {ENTEGRASYONLAR.filter((e) => e.kategori === k).map((e) => (
                  <StaggerItem key={e.ad} className="h-full">
                    <Kart className="h-full p-5">
                      <div className="flex items-center justify-between gap-2">
                        <p className="font-semibold text-ink">{e.ad}</p>
                        {etiket[e.durum] && <Rozet tone="warning">{etiket[e.durum]}</Rozet>}
                      </div>
                      <p className="mt-1.5 text-sm leading-relaxed text-ink-2">{e.aciklama}</p>
                    </Kart>
                  </StaggerItem>
                ))}
              </Stagger>
            </div>
          ))}
        </Section>
      </SayfaUstu>
      <SonCta
        baslik="Kullandığınız sağlayıcı listede yok mu?"
        metin="Söyleyin. Sanal POS ve SMS sağlayıcıları benzer arayüzlerle çalışır; sık istenen bir sağlayıcıyı yol haritasına alırız."
      />
    </>
  )
}
